export default __webpack_public_path__ + "assets/editing-interface.3fb6ee58.jpg";